<template>
  <el-breadcrumb class="app-breadcrumb" separator="/">
    <transition-group name="breadcrumb">
      <el-breadcrumb-item :to="{ path: '/' }" v-if="isShowHome" key="home">{{homeName}}</el-breadcrumb-item>
      <el-breadcrumb-item v-for="(item,index) in levelList" :key="item.path" v-if="item.meta.title">
        <span
            v-if="item.redirect==='noredirect' || index == levelList.length - 1"
            class="no-redirect">{{item.meta.title}}</span>
        <router-link v-else :to="{path: item.redirect || item.path, query: $route.query}" class="break-inner-item">{{item.meta.title}}</router-link>
      </el-breadcrumb-item>
    </transition-group>
  </el-breadcrumb>
</template>

<script>

export default {
    props:{
        isShowHome:{
            type:Boolean,
            default:false
        },
        homeName:{
            type:String,
            default:'首页'
        }
    },
    created() {
        this.getBreadcrumb()
    },
    data() {
        return {
            levelList: null
        }
    },
    watch: {
        $route() {
            this.getBreadcrumb()
        }
    },
    methods: {
        getBreadcrumb() {
            // console.log(this.$route)
            let matched = this.$route.matched.filter(item => item.name)
            this.levelList = matched;
            // console.log(matched)
        }
    }
}
</script>

<style lang="scss" scoped>
  .app-breadcrumb.el-breadcrumb {
    font-size: 14px;
    margin-left: 10px;
    .no-redirect {
      color: #97a8be;
      cursor: text;
    }
    .break-inner-item{
      position: relative;
      bottom: 2px;
    }
  }
</style>
